import React from 'react';
import { YSelect } from '../../../ui/YSelect';
import {
  hasSeasonChoice,
  hasSeasons,
  seasonPickerOptions,
  seasonSummaryLabel,
} from '../utils/clubSeasonPicker';

/**
 * Season selector for the club Stats tab. Every number on this tab is scoped to
 * the season named here. A club with only one season still gets the label — it
 * just is not a dropdown, because there is nothing to pick.
 */
export function ClubSeasonPicker({ seasons, value, onChange, disabled = false }) {
  if (!hasSeasons(seasons)) return null;

  const options = seasonPickerOptions(seasons);
  const summary = seasonSummaryLabel(seasons, value);
  const selectable = hasSeasonChoice(seasons);
  const only = options[0];

  return (
    <div className="club-stats-season-picker" data-testid="club-stats-season-picker">
      {selectable ? (
        <>
          <label className="club-stats-season-picker__label" htmlFor="club-stats-season">
            Season
          </label>
          <YSelect
            id="club-stats-season"
            value={value || ''}
            onChange={(event) => onChange(event.target.value)}
            disabled={disabled}
          >
            {options.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
                {option.isCurrent ? ' (current)' : ''}
              </option>
            ))}
          </YSelect>
        </>
      ) : (
        <>
          <span className="club-stats-season-picker__label">Season</span>
          <span className="club-stats-season-picker__only" data-testid="club-stats-season-only">
            {only.label}
            {only.isCurrent ? ' (current)' : ''}
          </span>
        </>
      )}
      {summary ? <span className="club-stats-season-picker__summary">{summary}</span> : null}
    </div>
  );
}
